<div class="main_content">

    <div class="first_text">
        <p>Follow these steps to start using Taxonomy Builder:</p>
    </div>

    <ol class="list-number">
        <li>Complete the authorization process</li>
        <li>Select a client from the list</li>
        <li>Select a taxonomy from the list</li>
        <li>Click “Add to Sheet” to create a table</li>
        <li>Click “Submit Values” when you are done editing the table</li>
    </ol>

    <div class="add_to_sheet">
        <a routerLink="/login">
            <span>GET STARTED</span>
        </a>
    </div>

</div>
